import React, { memo } from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    phase: 'Fase de Limpieza',
    days: 'Día 1-2',
    desc: 'Eliminamos los "cortocircuitos" inflamatorios de tu dieta actual.'
  }, {
    phase: 'Fase de Activación',
    days: 'Día 3-5',
    desc: 'Introducimos el Elixir de Claridad para alimentar las neuronas con energía de respaldo.'
  }, {
    phase: 'Fase de Anclaje',
    days: 'Día 6-7',
    desc: 'Aplicamos técnicas de gestión de cortisol para que tu memoria responda siempre bajo presión.'
  }];
  return <section className="w-full bg-white py-20 px-6" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <FadeIn data-id="element-81">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-82">
            Cómo funciona el protocolo
          </h2>

          <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-sage/30 before:to-transparent" data-id="element-83">
            {steps.map((step, index) => <div key={index} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-84">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-sage text-white font-bold shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-85">
                  {index + 1}
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-cream p-6 rounded-xl border border-cream-dark shadow-sm" data-id="element-86">
                  <div className="flex items-center justify-between mb-2" data-id="element-87">
                    <h3 className="font-bold text-sage text-lg m-0" data-id="element-88">
                      {step.phase}
                    </h3>
                    <span className="text-xs font-bold text-gold uppercase tracking-wider bg-white px-2 py-1 rounded-md" data-id="element-89">
                      {step.days}
                    </span>
                  </div>
                  <p className="text-charcoal-light m-0" data-id="element-90">{step.desc}</p>
                </div>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}